import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftCardCreate = lazy(
  () => import(/* webpackChunkName: 'GiftCardCreate' */ './Create'),
);

export default function GiftCardCreate() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftCardCreate />
    </Suspense>
  );
}
